<template>
	<div class="contactAfter_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<!-- コンテンツ -->
		<div class="contents_area">
			<div class="comment">
				<h1 style="margin-top:26px">送信完了</h1>
				<br>
				お問い合わせ頂きありがとうございます。<br>
				お問い合わせ内容を指定されたメールアドレスに送信いたしますので、ご確認をお願い致します。<br>
				確認メールが届かない場合は、メールアドレスのご確認、または、お使いのメールツールの迷惑メールフォルダ等をご確認願います。<br>
			</div>
			<div class="button_area">
				<div class="button" @click.stop="jump('/')">ホームへ戻る</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'contactPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	},
	methods: {
		jump(path) {
			this.$router.push(path);
		}
	}
}
</script>

<style lang="less" scoped>
.contactAfter_page {
	.contents_area {
		padding: 60px 80px 80px 80px;
		
		.button_area {
			width: 100%;
			text-align: center;
			margin-top: 80px;
			
			.button {
				width: 130px;
				margin-left: auto;
				margin-right: auto;
				font-size: 1.5rem;
				border-radius: 10px;
				padding: 12px 28px;
				background-color: #71abf7;
				color: white;
				cursor: pointer;
				font-weight: bold;
				border-width: 0;
			}
		}
	}
}

@media(max-width:420px) {
	.contactAfter_page {
		.contents_area {
			padding: 60px 28px;
		}
	}
}
</style>
